@charset "UTF-8";

/* src/app/shared/components/source-question/source-question.component.scss */
.question-head {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: black;
}
.source-container {
  overflow-y: hidden;
  overflow-x: hidden;
}
.ahe-ui-checkbox {
  cursor: pointer;
}
.hideChildren ~ ul {
  display: none;
}
.question-dropped .question-list {
  cursor: url(/assets/img/dpgicon.PNG), auto;
  font-weight: normal;
}
.question-dropped .question-list span:hover {
  cursor: pointer;
  color: #007c91;
  text-decoration: underline;
}
.question-dropped .question-list label {
  position: relative;
  padding-bottom: 15px;
}
.questions-unused .question-list {
  cursor: url(/assets/img/dpgicon.PNG), auto;
  font-weight: bold;
}
.questions-unused .question-list span:hover {
  cursor: pointer;
  color: #007c91;
  text-decoration: underline;
}
.questions-unused .question-list label {
  position: relative;
  padding-bottom: 15px;
}
.question-title span:hover {
  cursor: pointer;
  color: #007c91;
  text-decoration: underline;
}
.line-divider {
  border-top: 1px solid #bdbdbd;
}
#sourceFooter {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  height: 80px;
  background-color: #eaeaea;
  border-top: 1px solid #cccccc;
}
ul,
#myUL {
  list-style-type: none;
}
#myUL {
  margin: 0;
  padding: 0;
}
.caret {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.caret::before {
  content: "\25b6";
  color: black;
  display: inline-block;
  margin-right: 6px;
}
.caret-down::before {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.nested {
  display: none;
}
.active {
  display: block;
}
.checkbox-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.css-label {
  cursor: pointer;
}
.css-checkbox {
  display: none;
}
.fa {
  color: white;
  line-height: 16px;
  border-radius: 4px;
}
.fa-plus {
  padding-top: 2px;
  padding-right: 2px;
  padding-left: 2px;
  background-color: #3ac5c9;
  display: block;
}
.fa-minus {
  padding-top: 1px;
  padding-right: 2px;
  padding-left: 2px;
  background-color: #3ac5c9;
  display: block;
}
.highlight-name {
  font-weight: 900;
}
.highlight-bg {
  background-color: #cecece;
}
.bank-items :hover {
  cursor: pointer;
  font-weight: 900;
}
.assessment-breadcrumb {
  list-style: none;
  overflow: hidden;
  font: 18px Sans-Serif;
}
.assessment-breadcrumb li {
  float: left;
}
.assessment-breadcrumb li a {
  color: white;
  text-decoration: none;
  padding: 10px 0 10px 65px;
  background: hsl(34, 1%, 28%);
  position: relative;
  display: block;
  float: left;
}
.assessment-breadcrumb li a::after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 30px solid hsl(34, 1%, 28%);
  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 100%;
  z-index: 2;
}
.assessment-breadcrumb li:first-child a {
  padding-left: 10px;
}
.assessment-breadcrumb li:nth-child(2) a {
  background: hsl(34, 1%, 38%);
}
.assessment-breadcrumb li:nth-child(2) a:after {
  border-left-color: hsl(34, 1%, 38%);
}
.assessment-breadcrumb li:nth-child(3) a {
  background: hsl(34, 1%, 48%);
}
.assessment-breadcrumb li:nth-child(3) a:after {
  border-left-color: hsl(34, 1%, 48%);
}
.assessment-breadcrumb li:nth-child(4) a {
  background: hsl(34, 1%, 58%);
}
.assessment-breadcrumb li:nth-child(4) a:after {
  border-left-color: hsl(34, 1%, 58%);
}
.assessment-breadcrumb li:nth-child(5) a {
  background: hsl(34, 1%, 68%);
}
.assessment-breadcrumb li:nth-child(5) a:after {
  border-left-color: hsl(34, 1%, 68%);
}
.assessment-breadcrumb li a:hover {
  background: hsl(34, 1%, 18%);
}
.assessment-breadcrumb li a:hover:after {
  border-left-color: hsl(34, 1%, 18%) !important;
}
.sort-container {
  position: relative;
  margin-left: 5px;
}
.sort-container .fa {
  color: #0c0c0c;
}
.sort-container .fa-caret-down,
.sort-container .fa-caret-up {
  position: absolute;
  height: 5px;
  line-height: 5px;
}
.sort-container .fa-caret-up {
  top: 0;
}
.sort-container .fa-caret-down {
  bottom: 0;
}
.fixed_header {
  width: 100%;
  display: table;
}
.fixed_header thead {
  display: table;
  width: calc(100% - 17px);
}
.fixed_header tbody {
  display: block;
  overflow-y: auto;
  margin-right: 17px;
  border: 1px solid #bdbdbd;
}
.fixed_header th,
.fixed_header td {
  padding: 5px;
  word-break: break-word;
}
.selectedTd {
  background-color: #f0f3f4;
}
.fixed_header tr {
  display: table;
  width: 100%;
}
.fixed_header th:nth-child(1),
td:nth-child(1) {
  width: 70%;
}
.fixed_header th:nth-child(2),
td:nth-child(2) {
  width: 30%;
}
.alignment-row {
  top: -7px;
  position: relative;
}
.alignment-row1 {
  position: relative;
  bottom: 6px;
  left: 4px;
}
.qpickerIcons.algorithmicBig {
  background-position: -36px !important;
  display: inline-block;
  height: 28px;
  width: 24px;
}
.overflow {
  width: 100%;
  display: table;
}
.overflow thead {
  display: table;
  width: calc(96% - 17px) !important;
}
.overflow tbody {
  display: block;
  overflow-y: auto;
  margin-right: 17px;
  border: 1px solid #bdbdbd;
  width: calc(96% - 17px) !important;
}
.overflow td,
.overflow th {
  padding: 5px;
  word-break: break-all;
}
.overflow tr {
  display: table;
  width: 100%;
}
.overflow th:nth-child(1),
td:nth-child(1) {
  width: 70%;
}
.overflow th:nth-child(2),
td:nth-child(2) {
  width: 30%;
}
.modal-content {
  z-index: 1010;
  text-align: left;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  z-index: 1010;
  margin: 0px auto;
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
#okCancelModal .modal-footer {
  display: inline-block;
  text-align: center;
}
#okCancelModal .modal-footer .ahe-ui-checkbox {
  font-size: 13px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 30px;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.modal-dialog-copy {
  position: fixed;
  top: 50%;
  width: 27%;
  left: 33%;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background-color: #f0f3f4;
}
.modal-footer-new button {
  width: 130px;
}
.div-cont {
  clear: both;
  display: table;
}
.child-cont-1 {
  float: left;
  width: 17%;
  padding: 5px;
}
.child-cont-2 {
  float: left;
  width: 65%;
  padding: 13px 10px 0px 13px;
  color: black;
}
.section-break-cont {
  border: 1px #f0f3f4 solid;
  background-color: #f0f3f4;
}
.section-part-tbl {
  width: 94%;
  margin-left: 63px;
  border-collapse: separate;
  border-radius: 6px;
  border: solid 1px #bdbdbd;
  -moz-border-radius: 6px;
  border-spacing: 4px;
  background-color: white;
}
.section-part-tbl tr {
  border: none;
}
.section-part-tbl td {
  font-weight: bold;
}
.section-part-tbl td:first-child {
  border-left: none;
}
.section-part-tbl tbody {
  border: none !important;
  margin: 0px !important;
}
.sec-td-wt-1 {
  width: 78% !important;
}
.sec-td-wt-2 {
  width: 72% !important;
}
.sec-td-wt-3 {
  width: 62% !important;
}
.sec-td-wt-4 {
  width: 78% !important;
}
.sec-td-wt-5 {
  width: 76% !important;
}
.display-text {
  position: relative;
  top: 7px;
}
.sectionBrankLink {
  cursor: pointer;
}
.sectionBrankLink:hover {
  cursor: pointer;
  color: #007c91;
  text-decoration: underline;
}
.pill-btn {
  border-radius: 20px;
  padding: 0 10px;
  height: 30px;
  display: flex;
  align-items: center;
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #fff !important;
  background-color: #337ab7 !important;
  border-color: #2e6da4 !important;
}
.select-div {
  margin-top: 50px !important;
  max-width: 66px;
}
.min-width {
  min-width: 520px;
}
.p-text {
  margin-top: 3px !important;
  margin-left: 3px;
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #222222;
  margin-bottom: 4px;
  padding-left: 0;
  margin-left: 0;
}
.bottom-18 {
  margin-bottom: 18px !important;
  position: relative;
}
.answer-span {
  position: relative;
  display: inline-block;
  top: -5px;
  left: 5px;
  text-decoration: underline;
  color: #00798F;
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
}
span.answer-span:hover {
  cursor: pointer;
}
.title-question {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
}
.height-20 {
  height: 20px !important;
  position: relative;
  top: -8px;
  display: inline-block;
}
.title-div {
  margin-bottom: 10px;
  top: 8px !important;
  position: relative;
  font-size: 14px;
  font-weight: 900;
  padding-bottom: 0 !important;
}
.left-pad {
  padding: 0 0 0 21px;
  top: 5px;
}
.question-head {
  position: relative;
  text-align: left;
  top: 5px;
  margin: 0;
}
.checkbox-td {
  position: relative;
  top: -12px;
}
.new-head thead tr:nth-child(1) {
  height: 50px;
  background: #e0e7e9;
  border-bottom: 1px solid #e0e7e9;
}
.new-head th {
  background: #e0e7e9;
  border-bottom: 1px solid #e0e7e9;
}
@media only screen and (min-width: 1510px) {
  .min-width {
    min-width: 593px;
  }
}
@media only screen and (min-width: 1700px) {
  .min-width {
    min-width: 695px !important;
  }
}
@media only screen and (min-width: 1820px) {
  .min-width {
    min-width: 739px !important;
  }
}
.show-answers-button,
.hide-answers-button {
  background-color: transparent;
  border: none;
}
.display-answer-div:focus-visible {
  outline: none !important;
}
/*# sourceMappingURL=source-question.component.css.map */
